import { MaxLength, IsDefined } from 'class-validator';
import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class ProductProviderDataService extends DataService<typeof Model.Products.Logic.ViewModels.ProductProviderItem, Model.Products.Logic.ViewModels.ProductProviderItem, ProductProviderItem> {
	protected map(entity: Model.Products.Logic.ViewModels.ProductProviderItem): ProductProviderItem {
		return new ProductProviderItemModel(entity);
	}

	static make(ctx?: any): ProductProviderDataService {
		return new ProductProviderDataService(ctx, ctx => ctx.ProductProviders);
	}
}

export class ProductProviderItemModel extends EntityModel<Model.Products.Logic.ViewModels.ProductProviderItem, ProductProviderItem> implements ProductProviderItem {
	@property<ProductProviderItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<ProductProviderItemModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	@IsDefined({ message: 'name is required' })
	@MaxLength(128)
	public name: string;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForCarRent, (o, value) => o.entity.isActiveForCarRent = value)
	public isActiveForCarRent: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForAccommodation, (o, value) => o.entity.isActiveForAccommodation = value)
	public isActiveForAccommodation: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForFlight, (o, value) => o.entity.isActiveForFlight = value)
	public isActiveForFlight: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForGeneral, (o, value) => o.entity.isActiveForGeneral = value)
	public isActiveForGeneral: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForTransfer, (o, value) => o.entity.isActiveForTransfer = value)
	public isActiveForTransfer: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForTour, (o, value) => o.entity.isActiveForTour = value)
	public isActiveForTour: boolean;

	@property<ProductProviderItemModel>(o => o.entity.apiName, (o, value) => o.entity.apiName = value)
	public apiName: string;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForApiCarRent, (o, value) => o.entity.isActiveForApiCarRent = value)
	public isActiveForApiCarRent: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForApiAccommodation, (o, value) => o.entity.isActiveForApiAccommodation = value)
	public isActiveForApiAccommodation: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForApiFlight, (o, value) => o.entity.isActiveForApiFlight = value)
	public isActiveForApiFlight: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForApiGeneral, (o, value) => o.entity.isActiveForApiGeneral = value)
	public isActiveForApiGeneral: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForApiTransfer, (o, value) => o.entity.isActiveForApiTransfer = value)
	public isActiveForApiTransfer: boolean;

	@property<ProductProviderItemModel>(o => o.entity.isActiveForApiTour, (o, value) => o.entity.isActiveForApiTour = value)
	public isActiveForApiTour: boolean;

	@property<ProductProviderItemModel>(o => o.entity.canInitializeData, (o, value) => o.entity.canInitializeData = value)
	public canInitializeData: boolean;

	@property<ProductProviderItemModel>(o => o.entity.supplierId, (o, value) => o.entity.supplierId = value)
	public supplierId: number;

	@property<ProductProviderItemModel>(o => o.entity.supplierDefaultCurrencyIsoCode, (o, value) => o.entity.supplierDefaultCurrencyIsoCode = value)
	public supplierDefaultCurrencyIsoCode: string;

	@property<ProductProviderItemModel>(o => o.entity.cacheTimeForAccommodation, (o, value) => o.entity.cacheTimeForAccommodation = value)
	public cacheTimeForAccommodation: number;

	@property<ProductProviderItemModel>(o => o.entity.cacheTimeForCarRent, (o, value) => o.entity.cacheTimeForCarRent = value)
	public cacheTimeForCarRent: number;

	@property<ProductProviderItemModel>(o => o.entity.cacheTimeForFlight, (o, value) => o.entity.cacheTimeForFlight = value)
	public cacheTimeForFlight: number;

	@property<ProductProviderItemModel>(o => o.entity.cacheTimeForGeneral, (o, value) => o.entity.cacheTimeForGeneral = value)
	public cacheTimeForGeneral: number;

	@property<ProductProviderItemModel>(o => o.entity.cacheTimeForTransfer, (o, value) => o.entity.cacheTimeForTransfer = value)
	public cacheTimeForTransfer: number;

	@property<ProductProviderItemModel>(o => o.entity.cacheTimeForTour, (o, value) => o.entity.cacheTimeForTour = value)
	public cacheTimeForTour: number;

	@property<ProductProviderItemModel>(o => o.entity.requestLimits, (o, value) => o.entity.requestLimits = value)
	public requestLimits: number;

	@computed
	public get cacheTimeComputedForTransfer(): string {
		return this.cacheTimeForTransfer > 0 ? "Hurra!" : "";
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-providers/product-provider.data.ts